module.exports = __webpack_public_path__ + "img/0Q3C0560_Wood.3add6edb.jpg";